import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { navigation } from '../mockData';
import Logo from './Logo';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrollOpacity, setScrollOpacity] = useState(0);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isScrollingDown = scrollY > lastScrollY;
      
      // Header стає повністю чорним дуже пізно (~3500px)
      const maxScroll = 3500;
      
      // При скролі вгору - opacity зменшується швидше (в 2 рази)
      let opacity;
      if (isScrollingDown) {
        opacity = Math.min(scrollY / maxScroll, 0.95);
      } else {
        // При скролі вгору - швидше стає прозорим
        opacity = Math.min(scrollY / (maxScroll * 0.5), 0.95);
      }
      
      setScrollOpacity(opacity);
      setIsScrolled(scrollY > 500);
      setLastScrollY(scrollY);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToForm = () => {
    const form = document.querySelector('#contact-form');
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
      setTimeout(() => {
        document.querySelector('[data-testid="contact-name-input"]')?.focus({ preventScroll: true });
      }, 700);
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-shadow duration-700"
      style={{
        backgroundColor: `rgba(0, 0, 0, ${scrollOpacity})`,
        backdropFilter: scrollOpacity > 0.3 ? 'blur(12px)' : 'none',
        boxShadow: isScrolled ? '0 10px 15px -3px rgba(0, 0, 0, 0.1)' : 'none',
        transition: 'background-color 0.3s ease-out, backdrop-filter 0.3s ease-out, box-shadow 0.7s ease-in-out'
      }}
      >

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center md:py-4 !mx-[-19px] !bg-[rgba(255,255,255,0)]">
          {/* Logo - ідеальна версія з чорним фоном */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Nova-Stron — početak stranice"
            data-testid="header-logo-button"
            className="shrink-0 cursor-pointer bg-transparent border-0 p-0"
          >
            <img
              src="/gradnja/ns-logo.png"
              alt="Nova-Stron Logo"
              className="h-[108px] md:h-28 lg:h-32 w-auto !mt-[5px] md:!mt-[-10px] !mb-[5px] !ml-[10px] !mr-[10px] !pl-[14px] !pr-[14px] !rounded-[3px]" />
          </button>



          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-9">
            {navigation.map((item) =>
            <button
              key={item.name}
              onClick={() => scrollToSection(item.href)}
              className="relative text-gray-300 hover:text-[#cab28e] transition-colors duration-200 text-[13px] font-semibold tracking-[0.16em] uppercase after:absolute after:left-0 after:-bottom-1.5 after:h-px after:w-0 after:bg-[#cab28e] after:transition-[width] after:duration-300 hover:after:w-full">

                {item.name}
              </button>
            )}
            <Button
              onClick={scrollToForm}
              data-testid="header-cta-button"
              className="bg-[#cab28e] hover:bg-[#dfc8a2] text-black px-7 py-2.5 rounded-md transition-all duration-200 font-bold text-xs uppercase tracking-[0.14em] shadow-[0_0_20px_rgba(202,178,142,0.25)]">

              ZATRAŽITE PONUDU
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white p-2 mr-4">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="lg:hidden bg-black/98 backdrop-blur-md border-t border-gray-800">
          <div className="px-4 py-6 space-y-4">
            {navigation.map((item) =>
          <button
            key={item.name}
            onClick={() => scrollToSection(item.href)}
            className="block w-full text-left text-gray-300 hover:text-[#cab28e] transition-colors duration-200 py-2 text-base font-medium">

                {item.name}
              </button>
          )}
            <Button
            onClick={scrollToForm}
            data-testid="mobile-cta-button"
            className="w-full bg-[#cab28e] hover:bg-[#b8a07d] text-black py-3 rounded-md transition-all duration-200 font-semibold">

              ZATRAŽITE PONUDU
            </Button>
          </div>
        </div>
      }
    </header>);

};

export default Header;